import React from 'react';

interface Props {
    className?: string;
}

export const WebsiteIcon: React.FC<Props> = ({ className }) => {
    return (
        <svg className={`icon${className ? ` ${className}` : ''}`} width="20" height="20" viewBox="0 0 20 20">
            <path
                d="M10,0C4.5,0,0,4.5,0,10s4.5,10,10,10c5.5,0,10-4.5,10-10S15.5,0,10,0z M16.9,6H14c-0.3-1.2-0.8-2.4-1.4-3.6
                C14.4,3.1,16,4.3,16.9,6z M10,2c0.8,1.2,1.5,2.5,1.9,4H8.1C8.5,4.6,9.2,3.2,10,2z M2.3,12C2.1,11.4,2,10.7,2,10s0.1-1.4,0.3-2h3.4
                c-0.1,0.7-0.1,1.3-0.1,2s0.1,1.3,0.1,2H2.3z M3.1,14h3c0.3,1.2,0.8,2.5,1.4,3.6C5.6,16.9,4,15.7,3.1,14z M6,6h-3
                c1-1.7,2.5-2.9,4.3-3.6C6.8,3.6,6.4,4.8,6,6z M10,18c-0.8-1.2-1.5-2.5-1.9-4h3.8C11.5,15.4,10.8,16.8,10,18z M12.3,12H7.7
                c-0.1-0.7-0.2-1.3-0.2-2s0.1-1.4,0.2-2h4.7c0.1,0.6,0.2,1.3,0.2,2S12.4,11.3,12.3,12z M12.6,17.6c0.6-1.1,1.1-2.3,1.4-3.6h2.9
                C16,15.6,14.4,16.9,12.6,17.6z M14.4,12c0.1-0.7,0.1-1.3,0.1-2s-0.1-1.3-0.1-2h3.4c0.2,0.6,0.3,1.3,0.3,2s-0.1,1.4-0.3,2H14.4z"
            />
        </svg>
    );
};
